import { KontableComponent } from './../../../modules/UIKit/components/kontable/kontable.component';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { State } from '../../../models/state.model';
import { DataTableService } from '../../../modules/UIKit/components/dataTable/dataTable.service';
import { DataTableField } from '../../../modules/UIKit/components/dataTable/dataTableField.interface';
import { StateService } from '../../../services/state/state.service';

@Component({
  selector: 'app-state',
  templateUrl: './state.component.html',
  styleUrls: ['./state.component.css'],
  providers: []
})
export class StateComponent implements OnInit {

  showDetail = false;
  selectedState: State = null;
  stateListTitles: DataTableField[];
  newDataAvailable = false;
  modalTitle = '';
  labels = {}
  paginationType = KontableComponent.ServerPagination;

  constructor(
    public srvState: StateService,
    private srvDataTable: DataTableService,
    private translate: TranslateService
  ) {
    this.translate.get(['stateList']).subscribe((res) => {
      console.log(res);
      this.stateListTitles = [
        { id: 'id', label: '#' },
        { id: 'code', label: res.stateList.code },
        { id: 'name', label: res.stateList.name },
        { id: 'description', label: res.stateList.description },
        { id: 'country_name', label: res.stateList.country }
      ];
    });
  }

  ngOnInit() {

    this.translate.get([
      'stateList.add_title',
      'stateList.edit_title'
    ]).subscribe((res) => {
      this.labels['add_title'] = res['stateList.add_title'];
      this.labels['edit_title'] = res['stateList.edit_title'];
    });
  }
  showAddOrEditDialog(data): void {
    this.modalTitle = data == null ? this.labels['add_title'] : this.labels['edit_title'];
    this.srvState.stateEditing = data == null ? new State() : data;
    this.showDetail = true;
  }

  onDialogHide (): void {
    this.modalTitle = '';
    this.showDetail = false;
  }

  delete (record): void {
    this.srvState.delete(record).subscribe(() => {
      this.newDataAvailable = true;
    });
  }

  recoverState(record) {
    this.srvState.recover(record).subscribe(() => {
      this.newDataAvailable = true;
    });
  }

  stateAdded($event): void {
    this.srvState.post($event).subscribe(() => {
      this.srvDataTable.get('dt_state').showDetail = false;
      this.showDetail = false;
      this.srvState.stateEditing = null;
      this.newDataAvailable = true;
    });
  }

  stateUpdated($event): void {
    this.srvState.put($event).subscribe(() => {
      this.srvDataTable.get('dt_state').showDetail = false;
      this.showDetail = false;
      this.srvState.stateEditing = null;
      this.newDataAvailable = true;
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/state/state.component.ts